module.exports = __webpack_public_path__ + "img/verify-id.1ee28810.svg";